// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Select, Option } from 'informed';

import {
  addAllergy,
  deleteAllergy,
  updateAllergy,
} from '../../../actions/treatmentActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';
import Typeahead from '../../Typeahead.jsx';

type Props = {
  allergies: Object[],
  activePatientId: string,
  addAllergy: Function,
  deleteAllergy: Function,
  updateAllergy: Function,
}

class AllergiesComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.dateNoted = moment(formValues.dateNoted, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteAllergy(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateAllergy(this.props.activePatientId, {
      allergyId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addAllergy(this.props.activePatientId, formData.values);
  }

  render() {
    const columns = [
      {
        Header: 'Allergen',
        id: 'allergen',
        editCell: item => <Typeahead field='allergen' initialValue={item.allergen} endpoint='allergen' />,
      },
      {
        Header: 'Reaction',
        id: 'reaction',
        editCell: item => <Typeahead field='reaction' initialValue={item.reaction} endpoint='reaction' />,
      },
      {
        Header: 'Severity',
        id: 'severity',
        editCell: item => (
          <Select field='severity' initialValue={item.severity}>
            <Option>--</Option>
            <Option value='Mild'>Mild</Option>
            <Option value='Medium'>Medium</Option>
            <Option value='Severe'>Severe</Option>
          </Select>
        ),
      },
      {
        Header: 'Date Noted',
        id: 'dateNoted',
        cell: item => (item.dateNoted ? moment(item.dateNoted).format() : '--'),
        editCell: item => <DateText field='dateNoted' item={item} />,
      },
    ];

    return (
      <Table
        columns={columns}
        data={this.props.allergies}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  allergies: state.patient.data.allergies,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addAllergy:
    (patientId, allergy) => dispatch(addAllergy(patientId, allergy)),
  deleteAllergy:
    (patientId, allergyId) => dispatch(deleteAllergy(patientId, allergyId)),
  updateAllergy:
    (patientId, allergy) => dispatch(updateAllergy(patientId, allergy)),
});

const Allergies = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AllergiesComponent);

export default Allergies;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/informationHistory/Allergies.jsx